import cookieService from 'services/cookie-service'
import { pushDataLayer } from 'utils/data-layer-push'
import { getCurrentLanguage } from '../utils/current-language'
import { t9n } from 't9n/t9n'
import { RegisterPayload } from 'models/endpoints-payload'
import { registerUserBiz } from 'services/register-user'
import { getCsrfTokenBiz } from 'services/csrf-token'
import { checkEmailAvailabilityBiz } from 'services/check-email-availability'
import {
  checkIfPayloadComplete,
  consentValidator,
  emailValidator,
  getBooleanField,
  getStringField,
  handleShowPassword,
  passwordValidator,
  resetAllErrorMSG,
  setInputErrorMSG,
} from './form-handling'

type FormContainer = Document | HTMLElement

declare const CMS_BASE_URL_WT: string
declare const BIZ_BASE_URL_WT: string

const currentLanguage = getCurrentLanguage()

// Function fetches data from form and create payload object.
const getFormData = (formContainer: FormContainer): RegisterPayload => {
  const promocode = formContainer.querySelector<HTMLInputElement>('[data-promocode-field]').value
  return {
    email: getStringField('[data-email-field]', emailValidator, formContainer),
    password: getStringField('[data-password-field]', passwordValidator, formContainer),
    promocode: promocode ? promocode : '',
    terms_and_conditions_accepted: getBooleanField('[data-checkbox-field="terms"]', consentValidator, formContainer),
    region: 'PL', // deprecated stuff - long history of WT
    language: currentLanguage,
  }
}

const handleFormSubmit = (formContainer: FormContainer = document): void => {
  resetAllErrorMSG(formContainer)
  const payload = getFormData(formContainer)
  if (checkIfPayloadComplete(payload)) {
    // Response was resolved as HTTP 200 (ok)
    checkEmailAvailabilityBiz(payload)
      .then(() => {
        // Grab CSRF Token to payload
        getCsrfTokenBiz().then((token) => {
          registerUserBiz({ ...payload, _csrf: token })
            .then((/* res */) => {
              cookieService.setItem('confirm_email', payload.email, 0.05, CMS_BASE_URL_WT) // TTL: 1H 20M 0S

              pushDataLayer('form_submitted', { form_name: 'Rejstracja z landingu', form_url: window.location.href })

              window.location.href = `${BIZ_BASE_URL_WT}/?lang=${payload.language}#/confirm-email`
            })
            .catch((/* err */) => {
              // TODO: Error handle
            })
        })
        // Send Request
      })
      .catch((/* res */) => {
        // TODO: Should consider HTTP status code check, to distinguish API response vs API fail
        setInputErrorMSG('[data-email-field]', t9n('formValidation.emailReserved', currentLanguage), formContainer)
      })
  }
}

export default function initForm(): void {
  const $submitButton = document.querySelector<HTMLButtonElement>('[data-submit-form]')
  const $showPasswordButton = document.querySelector<HTMLButtonElement>('[data-show-password-button]')
  const $passwordInput = document.querySelector<HTMLInputElement>('[data-password-field]')
  if ($submitButton) $submitButton.addEventListener('click', () => handleFormSubmit())
  if ($showPasswordButton)
    $showPasswordButton.addEventListener('click', () => handleShowPassword($showPasswordButton, $passwordInput))
}

export function initExitPopupForm(): void {
  const $form = document.querySelector<HTMLButtonElement>('[data-exit-popup]')
  const $submitButton = $form?.querySelector<HTMLButtonElement>('[data-submit-form]')
  const $showPasswordButton = $form?.querySelector<HTMLButtonElement>('[data-show-password-button]')
  const $passwordInput = $form?.querySelector<HTMLInputElement>('[data-password-field]')
  if ($submitButton) $submitButton.addEventListener('click', () => handleFormSubmit($form))
  if ($showPasswordButton)
    $showPasswordButton.addEventListener('click', () => handleShowPassword($showPasswordButton, $passwordInput))
}
